import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-card-payment-cancel',
  templateUrl: './card-payment-cancel.component.html',
  styleUrls: ['./card-payment-cancel.component.scss']
})
export class CardPaymentCancelComponent implements OnInit {
  
  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  goToDocuments() {
    this.router.navigate(['/documents']);
  }

  tryAgain() {
    // Go back to payment page
    history.back();
  }
} 